export default "__VITE_ASSET__BD9kRvqg__"